import { accountReducer } from './accountReducer';
import { coreReducer } from '../../../core/js/reducers/coreReducer';
import { quickshopReducer } from '../../../product/js/reducers/quickshopReducer';

/**
 * Render a template string
 * @param {Number} state - The current state
 * @param {String} action - The action that was emitted
 * @returns {object} redux application
 */
function accountApp(state = {}, action) {
    return {
        account: accountReducer(state.account, action),
        quickshop: quickshopReducer(state, state.quickshop, action),
        core: coreReducer(state.core, action)
    };
}

export default accountApp;
